import { ButtonVariant, ColorVariant, IconName, EntityContextMenuItemSpec, SizeVariant } from "@mitratech/north-star";
import { NSAction } from "../../../../../packages/north-star/src/library/types/interfaces";
import { CaseStatus } from "../../types/loa";

import { CaseAction, CaseActionConfirmState } from "./compontents/types";

// constants used for Close Case
export const caseConfirmCloseActions: NSAction[] = [
  {
    name: "case-close-cancel",
    text: "Cancel",
    size: SizeVariant.Medium,
    variant: ButtonVariant.Outlined,
    color: ColorVariant.Secondary,
  },
  {
    name: "case-close-confirm",
    text: "Yes, Close Case",
    size: SizeVariant.Medium,
    variant: ButtonVariant.Contained,
    color: ColorVariant.Primary,
  },
];

/** A case that can be closed (an Approved one) can also be cancelled. */
export const caseContextMenuItems: EntityContextMenuItemSpec[] = [
  { type: "button", id: "case-close-request", prefix: IconName.CheckCircleOutline, label: "Close Case" },
  { type: "button", id: "case-cancel-request", prefix: IconName.HighlightOff, label: "Cancel Case" },
];

/**
 * An Open case can be cancelled, but not closed: it closes only once approved
 * (LOA-1520), which the case page does.
 */
export const caseContextOpenMenuItems: EntityContextMenuItemSpec[] = [
  { type: "button", id: "case-cancel-request", prefix: IconName.HighlightOff, label: "Cancel Case" },
];

export const caseConfirmCloseState: CaseActionConfirmState = {
  isOpen: false,
  command: CaseAction.Close,
  actions: caseConfirmCloseActions,
  id: "case-close",
  title: "Close Case",
};

// constants used for Cancel Case
export const caseConfirmCancelActions: NSAction[] = [
  {
    name: "case-cancel-dismiss",
    text: "Cancel",
    size: SizeVariant.Medium,
    variant: ButtonVariant.Outlined,
    color: ColorVariant.Secondary,
  },
  {
    name: "case-cancel-confirm",
    text: "Yes, Cancel Case",
    size: SizeVariant.Medium,
    variant: ButtonVariant.Contained,
    color: ColorVariant.Primary,
  },
];

export const caseConfirmCancelState: CaseActionConfirmState = {
  isOpen: false,
  command: CaseAction.Cancel,
  actions: caseConfirmCancelActions,
  id: "case-cancel",
  title: "Cancel Case",
};

// constats used for Reopen Case
export const caseConfirmReopenActions: NSAction[] = [
  {
    name: "case-open-dismiss",
    text: "Cancel",
    size: SizeVariant.Medium,
    variant: ButtonVariant.Outlined,
    color: ColorVariant.Secondary,
  },
  {
    name: "case-open-confirm",
    text: "Reopen Case",
    size: SizeVariant.Medium,
    variant: ButtonVariant.Contained,
    color: ColorVariant.Primary,
  },
];

export const caseContextReopenMenuItems: EntityContextMenuItemSpec[] = [
  { type: "button", id: "case-reopen-request", prefix: IconName.Replay, label: "Reopen Case" },
];

export const caseConfirmReopenState: CaseActionConfirmState = {
  isOpen: false,
  command: CaseAction.Open,
  actions: caseConfirmReopenActions,
  id: "case-open",
  title: "Reopen Case",
};

/** The list's context menu for a case in `status`: only what its status allows. */
export function caseContextMenuItemsFor(status: CaseStatus): EntityContextMenuItemSpec[] {
  switch (status) {
    case CaseStatus.Open:
      return caseContextOpenMenuItems;
    case CaseStatus.Approved:
      return caseContextMenuItems;
    case CaseStatus.Closed:
    case CaseStatus.Cancelled:
    case CaseStatus.Denied:
      return caseContextReopenMenuItems;
    default:
      return [];
  }
}
